import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, radius, shadow, s as t, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const s = {
  page: { padding: '0' },
  header: { marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' },
  title: t.pageTitle,
  subtitle: t.pageSubtitle,
  tabs: ui.tabBar,
  tab: ui.tab,
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' },
  card: { background: colors.bgCard, borderRadius: radius.lg, padding: '20px', border: `1px solid ${colors.border}`, boxShadow: shadow.sm },
  cardTitle: { fontSize: '12px', fontWeight: 500, color: colors.textSecondary, marginBottom: '8px' },
  bigNum: { fontSize: '28px', fontWeight: 600, color: colors.textPrimary, letterSpacing: '-0.025em', fontVariantNumeric: 'tabular-nums', lineHeight: 1.2 },
  bigNumSub: { fontSize: '12px', color: colors.textSecondary, marginTop: '4px' },
  table: t.table,
  th: t.th,
  td: t.td,
  input: { ...t.input, width: 'auto', maxWidth: '100%' },
  barWrap: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' },
  barLabel: { width: '160px', flex: '0 1 160px', minWidth: 0, fontSize: '12px', color: colors.textSecondary, overflowWrap: 'anywhere' },
  barTrack: { ...ui.meter, flex: '1 1 60px', minWidth: 0 },
  barPct: { ...ui.numMuted, fontSize: '12px', marginLeft: '6px', whiteSpace: 'nowrap' },
}

function MultiSelect({ label, options, selected, onChange, minWidth = 150 }) {
  const [open, setOpen] = useState(false)
  const [sagaYasli, setSagaYasli] = useState(false)
  const ref = useRef(null)
  useEffect(() => {
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onDoc)
    return () => document.removeEventListener('mousedown', onDoc)
  }, [])
  useEffect(() => {
    if (!open || !ref.current) return
    const kutu = ref.current.getBoundingClientRect()
    setSagaYasli(kutu.left + 220 > window.innerWidth - 12)
  }, [open])
  const toggle = val => selected.includes(val) ? onChange(selected.filter(v => v !== val)) : onChange([...selected, val])
  const count = selected.length
  const norm = opt => (opt && opt.value !== undefined) ? opt : { value: opt, label: opt }
  return (
    <div ref={ref} className="sx-full-sm" style={{ position: 'relative', minWidth: 0, maxWidth: '100%' }}>
      <button type="button" onClick={() => setOpen(o => !o)} className="sx-full-sm"
        style={{ ...s.input, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', background: colors.bgCard,
          borderColor: count ? colors.primary : colors.border, color: count ? colors.primary : colors.textSecondary, minWidth: minWidth + 'px', maxWidth: '100%', justifyContent: 'space-between' }}>
        <span>{label}{count ? ` (${count})` : ''}</span>
        <span style={{ fontSize: '9px' }}>▼</span>
      </button>
      {open && (
        <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: sagaYasli ? 'auto' : 0, right: sagaYasli ? 0 : 'auto', zIndex: 60, background: colors.bgCard, border: `1px solid ${colors.border}`,
          borderRadius: radius.md, boxShadow: shadow.lg, padding: '6px', minWidth: '220px', maxWidth: 'calc(100vw - 32px)', maxHeight: 'min(300px, 60vh)', overflowY: 'auto' }}>
          {count > 0 && (
            <div onClick={() => onChange([])} style={{ fontSize: '12px', color: colors.textSecondary, cursor: 'pointer', padding: '6px 8px', borderBottom: `1px solid ${colors.borderLight}`, marginBottom: '4px' }}>Temizle</div>
          )}
          {options.map(o => { const opt = norm(o); const on = selected.includes(opt.value); return (
            <label key={opt.value} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 8px', borderRadius: radius.sm, cursor: 'pointer', fontSize: '13px', background: on ? colors.bgSelected : 'transparent', overflowWrap: 'anywhere' }}>
              <input type="checkbox" checked={on} onChange={() => toggle(opt.value)} style={{ accentColor: colors.primary }} />
              {opt.label}
            </label>
          )})}
          {options.length === 0 && <div style={{ ...ui.emptyText, fontSize: '12px', padding: '8px' }}>Seçenek yok</div>}
        </div>
      )}
    </div>
  )
}

export default function SmartCIP() {
  const { selectedBrand, account } = useBrand()
  const [tab, setTab] = useState('dashboard')
  const [cipActive, setCipActive] = useState(false)
  const [stats, setStats] = useState(null)
  const [customers, setCustomers] = useState([])
  const [total, setTotal] = useState(0)
  const [aggregates, setAggregates] = useState(null)
  const [sortBy, setSortBy] = useState('value_score')
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [ililceKirilim, setIlilceKirilim] = useState('il')
  const [ililceYuk, setIlilceYuk] = useState(false)
  const [filterSegment, setFilterSegment] = useState([])
  const [filterBehavior, setFilterBehavior] = useState([])
  const [filterInterest, setFilterInterest] = useState([])
  const [filterFootprint, setFilterFootprint] = useState([])
  const [filterMember, setFilterMember] = useState([])
  const [filterRhythm, setFilterRhythm] = useState([])
  const [filterPublisher, setFilterPublisher] = useState([])
  const [filterCategory, setFilterCategory] = useState([])
  const [filterPermission, setFilterPermission] = useState([])
  const [filterSource, setFilterSource] = useState([])
  const [filterCampaign, setFilterCampaign] = useState([])
  const [, setSelectedCustomer] = useState(null)
  const [customerDetail, setCustomerDetail] = useState(null)
  const [syncing, setSyncing] = useState(false)
  const [syncDurum, setSyncDurum] = useState(null)
  const [syncHata, setSyncHata] = useState('')
  const syncKosuyorduRef = useRef(false)
  const [loading, setLoading] = useState(false)
  const [statsHata, setStatsHata] = useState('')
  const [listeHata, setListeHata] = useState('')
  const [detayHata, setDetayHata] = useState('')
  const [ayarUyari, setAyarUyari] = useState('')
  const [ayarsizConfig, setAyarsizConfig] = useState(false)
  const istekRef = useRef(0)

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }
  const ayarsiz = (stats ? !!stats.ayarsiz : false) || ayarsizConfig
  const AYARSIZ_UYARI = 'Bu marka için CIP profil modeli tanımlı olmadığı sürece açılamaz.'

  useEffect(() => {
    if (!selectedBrand) return
    istekRef.current += 1
    setStats(null)
    setStatsHata('')
    setListeHata('')
    setCustomers([])
    setTotal(0)
    setAggregates(null)
    setCustomerDetail(null)
    setDetayHata('')
    setAyarUyari('')
    setAyarsizConfig(false)
    setCipActive(false)
    setSyncHata('')
    setPage(1)
    setIlilceKirilim('il')
    if (tab === 'detail') setTab('customers')
    setFilterSegment([]); setFilterBehavior([]); setFilterInterest([]); setFilterFootprint([])
    setFilterMember([]); setFilterRhythm([]); setFilterPublisher([]); setFilterCategory([])
    setFilterPermission([]); setFilterSource([]); setFilterCampaign([])
    fetchStats()
    fetchCipConfig()
    fetchSyncDurum()
  }, [selectedBrand?.id]) // eslint-disable-line

  useEffect(() => {
    if (!syncing || !selectedBrand) return
    const z = setInterval(fetchSyncDurum, 3000)
    return () => clearInterval(z)
  }, [syncing, selectedBrand?.id]) // eslint-disable-line

  function fetchSyncDurum() {
    if (!selectedBrand) return
    const istek = istekRef.current
    axios.get(`${API}/admin/brands/${selectedBrand.id}/cip/sync-status`, { headers })
      .then(r => {
        if (istek !== istekRef.current) return
        const d = r.data || {}
        const kosuyor = !!d.calisiyor
        if (syncKosuyorduRef.current && !kosuyor) {
          fetchStats()
          setSyncHata(d.son && d.son.status && d.son.status !== 'ok'
            ? 'Son senkron ' + d.son.status + ': ' + String(d.son.error || '').slice(0, 160) : '')
        }
        syncKosuyorduRef.current = kosuyor
        setSyncDurum(d)
        setSyncing(kosuyor)
      })
      .catch(() => {})
  }

  function fetchCipConfig() {
    const istek = istekRef.current
    axios.get(`${API}/admin/brands/${selectedBrand.id}/cip/config`, { headers })
      .then(r => {
        if (istek !== istekRef.current) return
        setCipActive(!!(r.data && r.data.is_active))
        setAyarsizConfig(!!(r.data && r.data.ayarsiz))
      })
      .catch(() => {
        if (istek !== istekRef.current) return
        setAyarUyari('CIP ayarı okunamadı; gösterilen durum güvenilir değil.')
      })
  }

  function toggleCipActive(next) {
    setCipActive(next)
    setAyarUyari('')
    axios.post(`${API}/admin/brands/${selectedBrand.id}/cip/config`, { is_active: next }, { headers })
      .catch(e => {
        setCipActive(!next)
        const d = (e.response && e.response.data) || {}
        if (d.code === 'marka_ayari_yok') {
          setAyarsizConfig(true)
          setAyarUyari(AYARSIZ_UYARI)
        } else {
          setAyarUyari('Kaydedilemedi, tekrar deneyin.')
        }
      })
  }

  async function istekHatasi(e, varsayilan) {
    const d = e.response && e.response.data
    if (d && typeof d.text === 'function') {
      try {
        const j = JSON.parse(await d.text())
        if (j && j.error) return j.error
      } catch (x) {
        return varsayilan
      }
    }
    if (d && d.error) return d.error
    return e.message || varsayilan
  }

  useEffect(() => {
    if (!selectedBrand || tab !== 'customers' || !stats || ayarsiz) return
    fetchCustomers()
  }, [selectedBrand?.id, stats, tab, page, filterSegment, filterBehavior, filterInterest, filterFootprint, filterMember, filterRhythm, filterPermission, filterSource, filterCampaign, filterPublisher, filterCategory, sortBy]) // eslint-disable-line

  function fetchStats() {
    const istek = istekRef.current
    setStatsHata('')
    axios.get(`${API}/admin/brands/${selectedBrand.id}/cip/stats`, { headers })
      .then(r => { if (istek === istekRef.current) setStats(r.data) })
      .catch(() => { if (istek === istekRef.current) setStatsHata('CIP özeti yüklenemedi — sayfayı yenileyin.') })
  }

  function fetchCustomers() {
    setLoading(true)
    const params = { page, limit: 20, search, segment: filterSegment.join(','), behavior: filterBehavior.join(','), interest: filterInterest.join(','), footprint: filterFootprint.join(','), member: filterMember.join(','), rhythm: filterRhythm.join(','), permission: filterPermission.join(','), source: filterSource.join(','), campaign: filterCampaign.join(','), publisher: filterPublisher.join(','), category: filterCategory.join(','), sort: sortBy }
    const istek = istekRef.current
    setListeHata('')
    axios.get(`${API}/admin/brands/${selectedBrand.id}/cip/customers`, { headers, params })
      .then(r => {
        if (istek !== istekRef.current) return
        setCustomers(r.data.customers)
        setTotal(r.data.total)
        setAggregates(r.data.aggregates)
        if (r.data.ayarsiz) setAyarsizConfig(true)
      })
      .catch(() => { if (istek === istekRef.current) setListeHata('Müşteri listesi yüklenemedi — filtreleri sadeleştirip tekrar deneyin.') })
      .finally(() => { if (istek === istekRef.current) setLoading(false) })
  }

  async function exportCSV() {
    try {
      const params = { segment: filterSegment.join(','), behavior: filterBehavior.join(','), interest: filterInterest.join(','), search, footprint: filterFootprint.join(','), member: filterMember.join(','), rhythm: filterRhythm.join(','), permission: filterPermission.join(','), source: filterSource.join(','), campaign: filterCampaign.join(','), publisher: filterPublisher.join(','), category: filterCategory.join(',') }
      const res = await axios.get(`${API}/admin/brands/${selectedBrand.id}/cip/export`, { headers, params, responseType: 'blob' })
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }))
      const a = document.createElement('a')
      a.href = url
      a.download = `cip-${selectedBrand.name}.csv`
      a.click()
      window.URL.revokeObjectURL(url)
    } catch (e) {
      alert('Export hatası: ' + (await istekHatasi(e, 'CSV indirilemedi')))
    }
  }

  async function ililceIndir() {
    setIlilceYuk(true)
    try {
      const res = await axios.get(`${API}/admin/brands/${selectedBrand.id}/il-ilce-raporu`, {
        headers, params: { kirilim: ililceKirilim }, responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }))
      const a = document.createElement('a')
      a.href = url
      a.download = `il-ilce-${ililceKirilim}-${selectedBrand.name}.csv`
      a.click()
      window.URL.revokeObjectURL(url)
    } catch (e) {
      alert('İl/İlçe raporu hatası: ' + (await istekHatasi(e, 'Rapor indirilemedi')))
    } finally {
      setIlilceYuk(false)
    }
  }

  function fetchCustomerDetail(email) {
    const istek = istekRef.current
    setSelectedCustomer(email)
    setCustomerDetail(null)
    setDetayHata('')
    setTab('detail')
    axios.get(`${API}/admin/brands/${selectedBrand.id}/cip/customer/${encodeURIComponent(email)}`, { headers })
      .then(r => { if (istek === istekRef.current) setCustomerDetail(r.data) })
      .catch(() => { if (istek === istekRef.current) setDetayHata('Müşteri detayı yüklenemedi.') })
  }

  function handleSync() {
    setSyncHata('')
    setSyncing(true)
    syncKosuyorduRef.current = true
    axios.post(`${API}/admin/brands/${selectedBrand.id}/cip/sync`, {}, { headers })
      .then(() => setTimeout(fetchSyncDurum, 1500))
      .catch(e => {
        syncKosuyorduRef.current = false
        setSyncing(false)
        setSyncHata((e.response && e.response.data && e.response.data.error) || 'Senkron başlatılamadı')
      })
  }

  if (!selectedBrand) return <div style={{ ...ui.notice, padding: '40px', textAlign: 'center' }}>Önce bir marka seçin.</div>

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div>
          <h2 style={s.title}>Smart CIP — {selectedBrand.name}</h2>
          <p style={s.subtitle}>Customer Intelligence Platform</p>
        </div>
        <div className="sx-wrap" style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <label title={ayarsiz
              ? AYARSIZ_UYARI
              : "Açıkken bu markanın profilleri her gece 03:00'te otomatik güncellenir"}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: ayarsiz && !cipActive ? 'not-allowed' : 'pointer', flexWrap: 'wrap', whiteSpace: 'nowrap', opacity: ayarsiz && !cipActive ? 0.55 : 1 }}>
              <input type="checkbox" checked={cipActive} disabled={ayarsiz && !cipActive} onChange={e => toggleCipActive(e.target.checked)} />
              <span style={ui.status(cipActive)}><span style={ui.statusDot(cipActive)} />Aktif</span>
              <span style={ui.chip}>{cipActive ? 'Gece 03:00 otomatik' : 'Otomatik kapalı'}</span>
            </label>
            {ayarUyari && (
              <span style={{ fontSize: '11px', color: colors.danger, maxWidth: '320px' }}>{ayarUyari}</span>
            )}
          </div>
          {account?.role === 'super_admin' && !ayarsiz && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
              <button onClick={handleSync} disabled={syncing}
                title={syncing ? 'Senkron sürüyor, bitmesini bekleyin' : 'Profilleri şimdi güncelle'}
                style={{ ...t.btnPrimary, padding: '10px 20px', opacity: syncing ? 0.65 : 1, cursor: syncing ? 'not-allowed' : 'pointer' }}>
                {syncing
                  ? '⟳ Senkron' + (syncDurum && syncDurum.yuzde != null ? ' %' + syncDurum.yuzde : '') + '…'
                  : '↻ Profilleri Güncelle'}
              </button>
              {syncing && syncDurum && syncDurum.adimAdi && (
                <span style={{ fontSize: '11px', color: colors.textMuted, whiteSpace: 'nowrap' }}>
                  {syncDurum.adim}/{syncDurum.toplamAdim} · {syncDurum.adimAdi}{syncDurum.detay ? ' · ' + syncDurum.detay : ''}
                </span>
              )}
              {!syncing && syncHata && (
                <span style={{ fontSize: '11px', color: colors.danger, maxWidth: '280px', textAlign: 'right' }}>{syncHata}</span>
              )}
            </div>
          )}
        </div>
      </div>

      {statsHata && (
        <div style={{ ...ui.notice, borderColor: colors.danger, color: colors.danger, marginBottom: '16px' }}>{statsHata}</div>
      )}

      {ayarsiz && (
        <div style={{ ...s.card, maxWidth: '760px' }}>
          <div style={{ ...s.cardTitle, fontSize: '15px', marginBottom: '10px' }}>Bu marka için CIP profil modeli tanımlı değil</div>
          <p style={{ fontSize: '13px', color: colors.textSecondary, lineHeight: 1.7, margin: '0 0 12px' }}>
            CIP, müşterileri markanın kendi kategori ağacına ve kendi sepet büyüklüklerine göre segmentler.
            Bu marka için o model tanımlanmadığı sürece CIP açılamaz ve profil üretilmez.
            Başka bir markanın modeli varsayılan olarak uygulanmaz.
          </p>
          <div style={{ fontSize: '12px', color: colors.textMuted }}>
            Model, markanın kendi sipariş ve kategori verisine bakılarak Seux ekibi tarafından tanımlanır.
          </div>
        </div>
      )}

      {!ayarsiz && !stats && !statsHata && (
        <div style={{ ...ui.emptyText, textAlign: 'center', padding: '40px' }}>Yükleniyor...</div>
      )}

      {!ayarsiz && stats && (
      <div style={s.tabs}>
        {[['dashboard','Dashboard'],['customers','Müşteriler'],['segments','Segmentler']].map(([k,l]) => (
          <button key={k} style={s.tab(tab===k)} onClick={() => { setTab(k); setListeHata('') }}>{l}</button>
        ))}
        {tab === 'detail' && <button style={s.tab(true)}>Müşteri Detayı</button>}
      </div>
      )}

      {/* DASHBOARD */}
      {!ayarsiz && tab === 'dashboard' && stats && (
        <>
          <div className="sx-grid-stat" style={s.grid4}>
            {[
              { label: 'Toplam Müşteri', val: parseInt(stats.stats.total).toLocaleString('tr-TR'), sub: `${parseInt(stats.stats.member||0).toLocaleString('tr-TR')} üye · ${parseInt(stats.stats.guest||0).toLocaleString('tr-TR')} misafir · ${parseInt(stats.stats.footprint||0).toLocaleString('tr-TR')} ayak izli` },
              { label: 'Ort. Harcama', val: parseFloat(stats.stats.avg_spent || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL', sub: 'müşteri başına' },
              { label: 'Ort. Sipariş', val: parseFloat(stats.stats.avg_orders || 0).toFixed(1), sub: 'müşteri başına' },
              { label: 'Ort. Değer Skoru', val: parseFloat(stats.stats.avg_value_score || 0).toFixed(0), sub: '/ 100' },
            ].map((item, i) => (
              <div key={i} style={s.card}>
                <div style={s.cardTitle}>{item.label}</div>
                <div style={s.bigNum}>{item.val}</div>
                <div style={s.bigNumSub}>{item.sub}</div>
              </div>
            ))}
          </div>

          <div className="sx-grid-panel" style={s.grid2}>
            {/* Değer Segmentleri */}
            <div style={s.card}>
              <div style={{ ...s.cardTitle, marginBottom: '16px' }}>Değer Segmentleri</div>
              {(stats.cipAyar?.degerSegmentleri || [])
                .map((ad, i) => ({ name: ad, count: Number([stats.stats.star, stats.stats.high, stats.stats.classic, stats.stats.newc, stats.stats.passive][i] || 0) }))
                .map(seg => {
                const pct = stats.stats.total > 0 ? Math.round((seg.count / stats.stats.total) * 100) : 0
                return (
                  <div key={seg.name} style={s.barWrap}>
                    <div style={s.barLabel}>{seg.name}</div>
                    <div style={s.barTrack}>
                      <div style={ui.meterFill(pct)}></div>
                    </div>
                    <div style={s.barPct}>{seg.count} ({pct}%)</div>
                  </div>
                )
              })}
            </div>

            {/* İlgi Segmentleri */}
            <div style={s.card}>
              <div style={{ ...s.cardTitle, marginBottom: '4px' }}>İlgi Alanı Segmentleri</div>
            <div style={{ fontSize: '11px', color: colors.textMuted, marginBottom: '14px' }}>
              {stats?.cipAyar?.esikTuru === 'adet'
                ? 'Ölçüt sahiplik: müşteri bu hattan en az bir ürün aldıysa segmente girer.'
                : 'Ölçüt pay: müşterinin aldığı ürünlerin yeterli oranı bu hatta düşüyorsa segmente girer.'}
            </div>
              {stats.segments.map(seg => {
                const pct = stats.stats.total > 0 ? Math.round((seg.count / stats.stats.total) * 100) : 0
                return (
                  <div key={seg.segment_name} style={s.barWrap}>
                    <div style={s.barLabel}>{seg.segment_name}</div>
                    <div style={s.barTrack}>
                      <div style={ui.meterFill(pct)}></div>
                    </div>
                    <div style={s.barPct}>{seg.count}</div>
                  </div>
                )
              })}
            </div>
          </div>

          <div className="sx-grid-panel" style={s.grid2}>
            {stats.cipAyar?.yazarAktif === true && (
            <div style={s.card}>
              <div style={{ ...s.cardTitle, marginBottom: '16px' }}>{stats.cipAyar?.etiketler?.enSadikBaslik || 'En Sadık Olunan Yazarlar'}</div>
              <div className="sx-scroll-x">
              <table style={s.table}>
                <thead><tr><th style={s.th}>{stats.cipAyar?.etiketler?.yazar || 'Yazar'}</th><th style={s.th}>Müşteri</th></tr></thead>
                <tbody>
                  {(stats.topAuthors || []).map((a, i) => (
                    <tr key={i}><td style={s.td}>{a.top_author}</td><td style={s.td}>{a.count}</td></tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
            )}

            {/* Davranış Segmentleri */}
            <div style={s.card}>
              <div style={{ ...s.cardTitle, marginBottom: '16px' }}>Davranış Segmentleri</div>
              {stats.behaviors.map(b => (
                <div key={b.behavior_segment} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap', padding: '8px 0', borderBottom: `1px solid ${colors.borderLight}` }}>
                  <span style={ui.chip}>{b.behavior_segment}</span>
                  <span style={ui.num}>{b.count}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* MÜŞTERİLER */}
      {!ayarsiz && tab === 'customers' && stats && (
        <div style={s.card}>
          {listeHata && (
            <div style={{ ...ui.notice, borderColor: colors.danger, color: colors.danger, marginBottom: '14px' }}>{listeHata}</div>
          )}
          <div className="sx-wrap" style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <input className="sx-full-sm" style={s.input} placeholder="E-mail ara..." value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && fetchCustomers()} />
            <MultiSelect label="Değer Segmenti" selected={filterSegment} onChange={v => { setFilterSegment(v); setPage(1) }}
              options={stats?.cipAyar?.degerSegmentleri || []} />
            <MultiSelect label="İletişim İzni" selected={filterPermission} onChange={v => { setFilterPermission(v); setPage(1) }}
              options={[{ value: 'var', label: 'İzin Var' }, { value: 'yok', label: 'İzin Yok' }, { value: 'belirsiz', label: 'Belirsiz' }]} />
            <MultiSelect label="Edinim (Kaynak)" selected={filterSource} onChange={v => { setFilterSource(v); setPage(1) }}
              options={['Reklamdan Etkilenen', 'Sosyal Medya Takipçisi', 'Ne Aldığını Bilen Araştırmacı', 'Sadık Müşteri', { value: 'belirsiz', label: 'Belirsiz' }]} />
            <MultiSelect label="Kampanya" selected={filterCampaign} onChange={v => { setFilterCampaign(v); setPage(1) }}
              options={[{ value: 'yes', label: 'Kampanya Tutkunu' }, { value: 'no', label: 'Değil' }]} />
            <MultiSelect label="Davranış" selected={filterBehavior} onChange={v => { setFilterBehavior(v); setPage(1) }}
              options={['Sessiz Müdavim','Keşifçi','Kararsız','Raf Gezen','Geri Dönen','Hızlı Karar Veren','Sepeti Bırakan','Araştıran Alıcı']} />
            <MultiSelect label="İlgi Alanı" selected={filterInterest} onChange={v => { setFilterInterest(v); setPage(1) }}
              options={(stats?.segments || []).map(seg => seg.segment_name)} />
            <MultiSelect label="Ritim" selected={filterRhythm} onChange={v => { setFilterRhythm(v); setPage(1) }}
              options={['Aktif','Gecikmiş','Uyuyan','Geri Dönen','Tek Sipariş','Sipariş Yok']} />
            {stats?.cipAyar?.yayineviAktif === true && (
            <MultiSelect label="Alışveriş Yapılan Marka" minWidth={190} selected={filterPublisher} onChange={v => { setFilterPublisher(v); setPage(1) }}
              options={(stats?.publishers || []).map(p => ({ value: p.name, label: `${p.name} (${Number(p.count).toLocaleString('tr-TR')})` }))} />
            )}
            <MultiSelect label="Alışveriş Yapılan Kategori" minWidth={200} selected={filterCategory} onChange={v => { setFilterCategory(v); setPage(1) }}
              options={(stats?.purchasedCategories || []).map(p => ({ value: p.name, label: `${p.name} (${Number(p.count).toLocaleString('tr-TR')})` }))} />
            <MultiSelect label="Ayak İzi" selected={filterFootprint} onChange={v => { setFilterFootprint(v); setPage(1) }}
              options={[{ value: 'yes', label: 'Aktif Takip' }, { value: 'no', label: 'Geçmiş Veri' }]} />
            <MultiSelect label="Üyelik" selected={filterMember} onChange={v => { setFilterMember(v); setPage(1) }}
              options={[{ value: 'yes', label: 'Üye' }, { value: 'no', label: 'Misafir' }]} />
            <button style={t.btnSecondary} onClick={exportCSV}>CSV İndir</button>
            <span style={{ ...ui.numMuted, fontSize: '12px', alignSelf: 'center' }}>{total.toLocaleString('tr-TR')} müşteri</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: 'auto' }}>
              <select value={ililceKirilim} onChange={e => setIlilceKirilim(e.target.value)}
                style={{ ...s.input, padding: '8px', fontSize: '13px' }}>
                <option value="ozet">İl/İlçe — Özet</option>
                <option value="il">İl/İlçe — İl Bazlı</option>
                <option value="ilce">İl/İlçe — İlçe Bazlı</option>
                <option value="il-kategori">İl/İlçe — İl × Kategori</option>
                <option value="il-yayinevi">İl/İlçe — İl × Yayınevi</option>
              </select>
              <button style={t.btnSecondary} onClick={ililceIndir} disabled={ililceYuk}>
                {ililceYuk ? 'İndiriliyor...' : 'Rapor İndir'}
              </button>
            </div>
          </div>

          {aggregates && (
            <div className="sx-wrap" style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <div style={{ ...ui.statBox, flex: '1 1 220px', padding: '12px 16px' }}>
                <div style={ui.statLabel}>Toplam Harcama (filtreli)</div>
                <div style={{ ...ui.statValue, fontSize: '22px', margin: '4px 0 0' }}>{Math.round(aggregates.total_spent).toLocaleString('tr-TR')} TL</div>
              </div>
              <div style={{ ...ui.statBox, flex: '1 1 220px', padding: '12px 16px' }}>
                <div style={ui.statLabel}>Ortalama Sepet (filtreli)</div>
                <div style={{ ...ui.statValue, fontSize: '22px', margin: '4px 0 0' }}>{Math.round(aggregates.avg_basket).toLocaleString('tr-TR')} TL</div>
              </div>
            </div>
          )}

          {loading ? <div style={{ ...ui.emptyText, textAlign: 'center', padding: '40px' }}>Yükleniyor...</div> : (
            <div className="sx-scroll-x">
            <table className="sx-cards" style={s.table}>
              <thead>
                <tr>
                  {[
                    { label: 'E-mail' }, { label: 'Telefon' }, { label: 'Kaynak' }, { label: 'Üyelik' },
                    { label: 'Değer Segmenti' }, { label: 'Davranış' },
                    { label: 'Değer Skoru', key: 'value_score' },
                    { label: 'Toplam Harcama', key: 'total_spent' },
                    { label: 'Ort. Sepet', key: 'avg_order_value' },
                    { label: 'Sipariş', key: 'total_orders' },
                    { label: 'Son Sipariş', key: 'last_order_at' },
                    { label: '' },
                  ].map((h, i) => (
                    <th key={i}
                      style={{ ...s.th, ...(h.key ? { cursor: 'pointer', userSelect: 'none' } : {}), ...(h.key === sortBy ? { color: colors.primary } : {}) }}
                      onClick={h.key ? () => { setSortBy(h.key); setPage(1) } : undefined}>
                      {h.label}{h.key ? (h.key === sortBy ? ' ↓' : ' ⇅') : ''}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {customers.map((c, i) => (
                  <tr key={i} style={{ cursor: 'pointer' }} onClick={() => fetchCustomerDetail(c.email)}>
                    <td data-label="E-mail" style={s.td}><span style={{ fontWeight: 500 }}>{c.email}</span></td>
                    <td data-label="Telefon" style={s.td}>{c.phone || '—'}</td>
                    <td data-label="Kaynak" style={s.td}>
                      <span style={ui.chip}>{c.has_footprint ? 'Aktif Takip' : 'Geçmiş Veri'}</span>
                    </td>
                    <td data-label="Üyelik" style={s.td}>
                      <span style={ui.chip}>{c.is_member ? 'Üye' : 'Misafir'}</span>
                    </td>
                    <td data-label="Değer Segmenti" style={s.td}>
                      <span style={ui.chip}>
                        {c.value_segment}
                      </span>
                    </td>
                    <td data-label="Davranış" style={s.td}>
                      {c.behavior_segment && <span style={ui.chip}>{c.behavior_segment}</span>}
                    </td>
                    <td data-label="Değer Skoru" style={s.td}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <div style={{ ...ui.meter, width: '40px', height: '4px' }}>
                          <div style={ui.meterFill(c.value_score)}></div>
                        </div>
                        <span style={ui.num}>{c.value_score}</span>
                      </div>
                    </td>
                    <td data-label="Toplam Harcama" style={{ ...s.td, ...ui.num }}>{parseFloat(c.total_spent).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} TL</td>
                    <td data-label="Ort. Sepet" style={{ ...s.td, ...ui.numMuted }}>{parseFloat(c.avg_order_value || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} TL</td>
                    <td data-label="Sipariş" style={{ ...s.td, ...ui.numMuted }}>{c.total_orders}</td>
                    <td data-label="Son Sipariş" style={{ ...s.td, ...ui.numMuted }}>{c.last_order_at ? new Date(c.last_order_at).toLocaleDateString('tr-TR') : '-'}</td>
                    <td style={s.td}><button style={ui.btnSm}>Detay →</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}

          {/* Pagination */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginTop: '16px' }}>
            <button style={{ ...ui.btnSm, opacity: page === 1 ? 0.5 : 1, cursor: page === 1 ? 'default' : 'pointer' }}
              disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Önceki</button>
            <span style={{ ...ui.numMuted, alignSelf: 'center' }}>
              {page} / {Math.ceil(total / 20)}
            </span>
            <button style={{ ...ui.btnSm, opacity: page >= Math.ceil(total / 20) ? 0.5 : 1, cursor: page >= Math.ceil(total / 20) ? 'default' : 'pointer' }}
              disabled={page >= Math.ceil(total / 20)} onClick={() => setPage(p => p + 1)}>Sonraki →</button>
          </div>
        </div>
      )}

      {/* SEGMENTLER */}
      {!ayarsiz && tab === 'segments' && stats && (
        <div className="sx-grid-panel" style={s.grid2}>
          <div style={s.card}>
            <div style={{ ...s.cardTitle, marginBottom: '16px' }}>Değer Segmenti Dağılımı</div>
            {(stats.cipAyar?.degerSegmentleri || [])
              .map((ad, i) => ({ name: ad, count: Number([stats.stats.star, stats.stats.high, stats.stats.classic, stats.stats.newc, stats.stats.passive][i] || 0) }))
              .map(seg => (
              <div key={seg.name} style={{ padding: '12px 0', borderBottom: `1px solid ${colors.borderLight}`, cursor: 'pointer' }}
                onClick={() => { setFilterSegment([seg.name]); setPage(1); setTab('customers') }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap', marginBottom: '6px' }}>
                  <span className="sx-break" style={{ fontSize: '13px', fontWeight: 600, color: colors.textPrimary }}>{seg.name}</span>
                  <span style={ui.chip}>{seg.count} müşteri</span>
                </div>
                <div style={ui.meter}>
                  <div style={ui.meterFill(Math.round((seg.count / stats.stats.total) * 100))}></div>
                </div>
              </div>
            ))}
          </div>
          <div style={s.card}>
            <div style={{ ...s.cardTitle, marginBottom: '4px' }}>İlgi Alanı Segmentleri</div>
            <div style={{ fontSize: '11px', color: colors.textMuted, marginBottom: '14px' }}>
              {stats?.cipAyar?.esikTuru === 'adet'
                ? 'Ölçüt sahiplik: müşteri bu hattan en az bir ürün aldıysa segmente girer.'
                : 'Ölçüt pay: müşterinin aldığı ürünlerin yeterli oranı bu hatta düşüyorsa segmente girer.'}
            </div>
            {stats.segments.map(seg => (
              <div key={seg.segment_name} style={{ padding: '10px 0', borderBottom: `1px solid ${colors.borderLight}`, cursor: 'pointer' }}
                onClick={() => { setFilterInterest([seg.segment_name]); setPage(1); setTab('customers') }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap', marginBottom: '6px' }}>
                  <span className="sx-break" style={{ fontWeight: 500, fontSize: '13px', color: colors.textPrimary }}>{seg.segment_name}</span>
                  <span style={{ ...ui.numMuted, fontSize: '12px' }}>{seg.count} müşteri</span>
                </div>
                <div style={ui.meter}>
                  <div style={ui.meterFill(Math.round((seg.count / stats.stats.total) * 100))}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* MÜŞTERİ DETAYI */}
      {!ayarsiz && tab === 'detail' && stats && (
        <div>
          <button style={{ ...ui.btnSm, marginBottom: '20px' }}
            onClick={() => setTab('customers')}>← Müşterilere Dön</button>

          {detayHata ? (
            <div style={{ ...ui.notice, borderColor: colors.danger, color: colors.danger }}>{detayHata}</div>
          ) : !customerDetail ? (
            <div style={{ ...ui.emptyText, textAlign: 'center', padding: '40px' }}>Yükleniyor...</div>
          ) : (() => {
            const p = customerDetail.profile
            const tl = customerDetail.timeline
            return (
              <div className="sx-grid-panel" style={s.grid2}>
                {/* Sol kolon */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {/* Müşteri özeti */}
                  <div style={s.card}>
                    <div style={s.cardTitle}>Müşteri Özeti</div>
                    <div className="sx-break" style={{ fontSize: '17px', fontWeight: 600, color: colors.textPrimary, letterSpacing: '-0.02em', marginBottom: '4px' }}>{p.email}</div>
                    <div style={{ marginBottom: '6px', display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                      <span style={ui.chip}>{p.has_footprint ? 'Aktif Takip' : 'Geçmiş Veri'}</span>
                      <span style={ui.chip}>{p.is_member ? 'Üye' : 'Misafir'}</span>
                    </div>
                    {p.phone && <div style={{ ...ui.numMuted, color: colors.textPrimary, marginBottom: '4px' }}>{p.phone}</div>}
                    <div style={{ fontSize: '12px', color: colors.textSecondary, marginBottom: '16px' }}>
                      {p.city && p.district ? `${p.city} / ${p.district}` : p.city || '—'} •
                      Üyelik: {new Date(p.first_seen_at).toLocaleDateString('tr-TR')}
                    </div>
                    <div className="sx-grid-stat" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      {[
                        { l: 'Toplam Sipariş', v: p.total_orders },
                        { l: 'Toplam Harcama', v: parseFloat(p.total_spent).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL' },
                        { l: 'Ort. Sepet', v: parseFloat(p.avg_order_value).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL' },
                        { l: 'Ort. Ürün/Sepet', v: p.avg_items != null ? parseFloat(p.avg_items).toFixed(1) : '—' },
                        { l: 'Sıklık (gün/sip)', v: p.purchase_frequency != null ? parseFloat(p.purchase_frequency).toFixed(0) : 'tek sipariş' },
                        { l: 'Son Sipariş', v: p.last_order_at ? new Date(p.last_order_at).toLocaleDateString('tr-TR') : '—' },
                      ].map((item, i) => (
                        <div key={i} style={{ background: colors.bgPage, border: `1px solid ${colors.borderLight}`, borderRadius: radius.md, padding: '10px' }}>
                          <div style={{ ...ui.statLabel, marginBottom: '4px' }}>{item.l}</div>
                          <div style={{ ...ui.num, fontSize: '15px' }}>{item.v}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Segment özeti */}
                  <div style={s.card}>
                    <div style={s.cardTitle}>Segment Özeti</div>
                    <div style={{ marginBottom: '12px' }}>
                      <span style={ui.chipStrong}>
                        {p.value_segment}
                      </span>
                    </div>
                    {(p.source_label || p.is_campaign_lover) && (
                      <div style={{ marginBottom: '12px', display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        {p.source_label && <span style={ui.chip}>{p.source_label}</span>}
                        {p.is_campaign_lover && <span style={ui.chip}>Kampanya Tutkunu</span>}
                      </div>
                    )}
                    {p.rhythm_status && (
                      <div style={{ marginBottom: '12px' }}>
                        <span style={ui.chip}>{p.rhythm_status}</span>
                        <div style={{ fontSize: '12px', color: colors.textSecondary, marginTop: '6px' }}>
                          Tipik sıklık: {p.purchase_frequency != null ? Math.round(p.purchase_frequency) + ' günde bir' : 'tek sipariş'}
                          {p.last_order_at && ` · Son sipariş: ${Math.max(0, Math.floor((Date.now() - new Date(p.last_order_at)) / 86400000))} gün önce`}
                        </div>
                      </div>
                    )}
                    {p.interest_segments && p.interest_segments.filter(Boolean).map((seg, i) => (
                      <div key={i} style={{ marginBottom: '6px' }}>
                        <span style={{ ...ui.chip, whiteSpace: 'normal', overflowWrap: 'anywhere' }}>{seg.name} ({seg.score}%)</span>
                      </div>
                    ))}
                    {p.behavior_segment && (
                      <div style={{ marginTop: '8px' }}>
                        <span style={ui.chip}>{p.behavior_segment}</span>
                      </div>
                    )}
                  </div>

                  {/* Skorlar */}
                  <div style={s.card}>
                    <div style={s.cardTitle}>Skorlar</div>
                    {[
                      { l: stats?.cipAyar?.etiketler?.degerBasligi || 'Değer Skoru', v: p.value_score },
                      { l: 'İlgi Derinliği', v: p.interest_depth_score },
                      { l: 'Sadakat', v: p.loyalty_score },
                      { l: 'Satın Alma Niyeti', v: p.purchase_intent_score },
                      ...(stats?.cipAyar?.yazarAktif === true ? [{ l: stats?.cipAyar?.etiketler?.yazarSadakati || 'Yazar Sadakati', v: p.author_loyalty_score }] : []),
                    ].map(item => (
                      <div key={item.l} style={{ marginBottom: '12px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                          <span style={{ fontSize: '12px', color: colors.textSecondary }}>{item.l}</span>
                          <span style={{ ...ui.num, fontSize: '12px' }}>{item.v == null ? 'ölçülmedi' : Math.round(item.v) + ' / 100'}</span>
                        </div>
                        <div style={ui.meter}>
                          <div style={ui.meterFill(item.v == null ? 0 : Math.round(item.v))}></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Sağ kolon */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {/* İlgi haritası */}
                  <div style={s.card}>
                    <div style={s.cardTitle}>İlgi Haritası (Kategori Dağılımı)</div>
                    {p.interest_map && Object.entries(p.interest_map)
                      .sort((a, b) => b[1] - a[1]).slice(0, 8)
                      .map(([cat, count]) => {
                        const total = Object.values(p.interest_map).reduce((a, b) => a + b, 0)
                        const pct = Math.round((count / total) * 100)
                        return (
                          <div key={cat} style={s.barWrap}>
                            <div style={s.barLabel}>{cat}</div>
                            <div style={s.barTrack}>
                              <div style={ui.meterFill(pct)}></div>
                            </div>
                            <div style={s.barPct}>{pct}%</div>
                          </div>
                        )
                      })
                    }
                  </div>

                  {/* Hangi ürünü satın alır — satın alma potansiyeli */}
                  {p.potential_categories && p.potential_categories.length > 0 && (
                    <div style={s.card}>
                      <div style={s.cardTitle}>Hangi Ürünü Satın Alır</div>
                      {p.potential_categories.map((c, i) => (
                        <div key={i} style={s.barWrap}>
                          <div style={s.barLabel}>{c.name}</div>
                          <div style={s.barTrack}>
                            <div style={ui.meterFill(c.pct)}></div>
                          </div>
                          <div style={s.barPct}>{c.pct}%</div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Satın alınan ürünler + alt özellikleri */}
                  {p.purchased_products && p.purchased_products.length > 0 && (
                    <div style={s.card}>
                      <div style={s.cardTitle}>Satın Alınan Ürünler (alt özellikler)</div>
                      <div style={{ maxHeight: '260px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {p.purchased_products.map((pr, i) => (
                          <div key={i} style={{ borderBottom: `1px solid ${colors.borderLight}`, paddingBottom: '6px' }}>
                            <div className="sx-break" style={{ fontSize: '13px', fontWeight: 600, color: colors.textPrimary }}>{pr.name}</div>
                            {pr.attrs && Object.keys(pr.attrs).length > 0 && (
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
                                {Object.entries(pr.attrs).map(([k, vals]) => (
                                  <span key={k} style={{ ...ui.chip, whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
                                    {k}: {Array.isArray(vals) ? vals.join(', ') : String(vals)}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Favori yazarlar */}
                  {stats?.cipAyar?.yazarAktif === true && p.top_author && (
                    <div style={s.card}>
                      <div style={s.cardTitle}>{stats?.cipAyar?.etiketler?.favoriBaslik || 'Favori Yazarlar'}</div>
                      {p.author_map && Object.entries(p.author_map)
                        .sort((a, b) => b[1] - a[1]).slice(0, 5)
                        .map(([author, count], i) => {
                          const total = Object.values(p.author_map).reduce((a, b) => a + b, 0)
                          const pct = Math.round((count / total) * 100)
                          return (
                            <div key={author} style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap', padding: '8px 0', borderBottom: `1px solid ${colors.borderLight}` }}>
                              <span className="sx-break" style={{ fontSize: '13px', color: colors.textPrimary }}>{i + 1}. {author}</span>
                              <span style={ui.chip}>{pct}%</span>
                            </div>
                          )
                        })
                      }
                    </div>
                  )}

                  {/* Satın alınan yayınevleri */}
                  {stats?.cipAyar?.yayineviAktif === true && p.publisher_map && Object.keys(p.publisher_map).length > 0 && (
                    <div style={s.card}>
                      <div style={s.cardTitle}>{stats?.cipAyar?.etiketler?.yayineviBaslik || 'Satın Alınan Yayınevleri'}</div>
                      {Object.entries(p.publisher_map)
                        .sort((a, b) => b[1] - a[1]).slice(0, 5)
                        .map(([pub, count], i) => {
                          const total = Object.values(p.publisher_map).reduce((a, b) => a + b, 0)
                          const pct = Math.round((count / total) * 100)
                          return (
                            <div key={pub} style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap', padding: '8px 0', borderBottom: `1px solid ${colors.borderLight}` }}>
                              <span className="sx-break" style={{ fontSize: '13px', color: colors.textPrimary }}>{i + 1}. {pub}</span>
                              <span style={ui.chip}>{pct}%</span>
                            </div>
                          )
                        })
                      }
                    </div>
                  )}

                  {/* Zaman çizelgesi */}
                  <div style={s.card}>
                    <div style={s.cardTitle}>Son Aktiviteler</div>
                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                      {tl.map((event, i) => (
                        <div key={i} style={{ display: 'flex', gap: '12px', padding: '8px 0', borderBottom: `1px solid ${colors.borderLight}` }}>
                          <div style={{ fontSize: '13px', color: colors.textMuted, flexShrink: 0 }}>
                            {{'purchase':'','product_view':'','category_view':'','checkout_start':'','login':'','open_app':''}[event.event_type] || '•'}
                          </div>
                          <div>
                            <div style={{ fontSize: '12px', fontWeight: 600, color: colors.textPrimary }}>
                              {{'purchase':'Sipariş Verdi','product_view':'Ürün Görüntüledi','category_view':'Kategori Gezdi',
                                'checkout_start':'Sepete Gitti','login':'Giriş Yaptı','open_app':'Uygulamayı Açtı'}[event.event_type]}
                              {event.event_type === 'purchase' && event.meta?.amount && ` — ${parseFloat(event.meta.amount).toLocaleString('tr-TR',{maximumFractionDigits:0})} TL`}
                            </div>
                            <div style={{ ...ui.numMuted, fontSize: '11px', color: colors.textMuted }}>{new Date(event.created_at).toLocaleString('tr-TR')}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )
          })()}
        </div>
      )}
    </div>
  )
}